/**
 * Après un déploiement, les fichiers de l'ancienne version n'existent plus (404) : une caisse restée
 * ouverte plante en changeant d'écran, et réessayer la même adresse n'y change rien. Seul un
 * rechargement récupère la nouvelle version. Le panier survit, il est gardé dans localStorage.
 */
const STORAGE_KEY = 'visionpos_chunk_reload_at';
/** Si l'erreur revient juste après un rechargement, elle ne vient pas d'un déploiement : pas de boucle. */
const MIN_INTERVAL_MS = 60_000;

const CHUNK_ERROR_PATTERNS = [
  'Failed to fetch dynamically imported module',
  'error loading dynamically imported module',
  'Importing a module script failed',
  'Unable to preload CSS',
  'Loading chunk',
  'Loading CSS chunk',
];

export const isChunkLoadError = (error: unknown): boolean => {
  const message = error instanceof Error ? error.message : '';
  return CHUNK_ERROR_PATTERNS.some((pattern) => message.includes(pattern));
};

/** Renvoie true si un rechargement est lancé. */
export const reloadOnceForChunkError = (
  error: unknown,
  reload: () => void = () => window.location.reload(),
): boolean => {
  if (!isChunkLoadError(error)) return false;
  try {
    const last = Number(sessionStorage.getItem(STORAGE_KEY) ?? 0);
    if (Date.now() - last < MIN_INTERVAL_MS) return false;
    sessionStorage.setItem(STORAGE_KEY, String(Date.now()));
  } catch {
    return false;
  }
  reload();
  return true;
};
